<template>
    <div class="auth-container fhw">
        <div ref="rv_life_auth_mfe" class="fhw"></div>
    </div>
</template>

<script>
import {handleMFEMessages} from "../utils/messages";
import {handleMFENavigation, MFES} from "../utils/navigation";
import {EVENTS} from "../utils/events";
import {broadcast, CHANNELS} from "../../../utils/broadcast";
import {getDynamicScript} from "../utils/dynamic";

export default {
    name: "Auth",
    methods: {
        async handleLogin(close = true) {
            // If already logged in, do nothing
            if (this.dataStore.user) {
                return;
            }
            this.$root.$emit(EVENTS.PROCESSING);

            axios.get(globalApiUrl + '/users/user', {
                headers: {
                    accept: 'application/x.rvparkreviews.v3+json'
                },
                withCredentials: true
            }).then(async (response) => {
                if (response.data?.data?.users) {
                    broadcast(CHANNELS.MAIN, {type: 'logged_in', data: response.data.data.users[0]});
                    this.$root.$emit('send_user', response.data.data.users[0]);
                    this.$root.$emit('logged_in', response.data.data.users[0]);

                    if (close) this.close();
                } else {
                    this.$toast.error('There was an error logging you in. Please try again.');
                    if (close) this.close();
                }
            }).catch(async (error) => {
                this.module?.logout();
                if (error.response?.data?.data?.errors[0]) {
                    this.$toast.error(error.response?.data?.data?.errors[0]);
                } else {
                    this.$toast.error('There was an error logging you in. Please try again.');
                    if (close) this.close();
                }
            }).finally(() => {
                this.$root.$emit(EVENTS.READY);

                if (close) this.close();
            });
        },
        async mountMFE() {
            this.$root.$emit(EVENTS.PROCESSING);
            await this.module?.mount(this.$refs.rv_life_auth_mfe, {
                "showClose": true,
                "slug": this.getVueEnv('SSO_CLIENT_SLUG'),
                initialHistory: this.initialHistory,
            });
            this.$root.$emit(EVENTS.READY);
        },
        close() {
            this.$root.$emit(EVENTS.CLOSE);
        }
    },
    data() {
        return {
            module: null
        }
    },
    async mounted() {
        const {ready, error, module} = await getDynamicScript({
            url: `${this.getVueEnv('RVLIFE_AUTH_REMOTE_URL')}/remoteEntry.js`,
            scope: 'rv_life_auth',
            module: './RVLifeAuthApp'
        });

        if (ready) {
            this.module = module;
        } else {
            throw new Error(error);
        }
        // If user is already logged in, auth MFE shows blank page. Redirect to home.
        if (this.dataStore.user && (!this.$route.params.page || this.$route.params.page === '/')) {
            await this.close();
            return;
        }
        await this.mountMFE();

        const listener = (event) => {
            switch (event?.detail?.type) {
                case 'login':
                    this.handleLogin();
                    break;
                case 'register':
                    this.handleLogin(false);
                    break;
                case 'close':
                    this.close();
                    break;
                case 'message':
                    handleMFEMessages(event?.detail?.payload, MFES.AUTH)
                    break;
                case 'navigate':
                    handleMFENavigation(event?.detail?.extra, MFES.AUTH);
                    break;
                case 'verify_email':
                    this.handleLogin(false);
                    break;
                default:
                    break;
            }
        };

        const popStateListener = (event) => {
            if (event.state) {
                // The user clicked the back or forward button
                this.mountMFE();
            }
        }

        document.addEventListener('rvlife_auth', listener);
        window.addEventListener('popstate', popStateListener);

        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('rvlife_auth', listener);
            window.removeEventListener('popstate', popStateListener);
            if (this.$refs.rv_life_auth_mfe) {
                this.module?.unmount(this.$refs.rv_life_auth_mfe);
            }
        });
    },
    computed: {
        initialHistory() {
            const page = this.$route.params.page;

            return [page ? `/${page}` : '/']
        }
    },
}
</script>

<style scoped>
.auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.fhw {
    height: 100%;
    width: 100%;
}
</style>